import { expValEqualsNoExposure } from '@confluence/feature-experiments';

export const usePostOfficeHomeBannerEligible = () => {
	// https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/post_office_confluence_home_banner_experiment_-_v2/setup
	return {
		// suppress exposure because if feed is empty, users do not see the banner even if they are initially assigned to be in Variation
		isEligible: expValEqualsNoExposure(
			'post_office_confluence_home_banner_experiment_-_v2',
			'cohort',
			'variation',
		),
	};
};
